import * as constants from './constants';

export function fetchIngredients() {
  return {
    type: constants.FETCH_INGREDIENTS
  };
}
export function fetchIngredientsDone(ingredients) {
  return {
    type: constants.FETCH_INGREDIENTS_DONE,
    payload: ingredients
  };
}
export function fetchIngredientsFail(error) {
  return {
    type: constants.FETCH_INGREDIENTS_FAIL,
    payload: error
  };
}

export function fetchIngredient(itemCode) {
  return {
    type: constants.FETCH_INGREDIENT,
    payload: itemCode
  };
}
export function fetchIngredientDone(ingredient) {
  return {
    type: constants.FETCH_INGREDIENT_DONE,
    payload: ingredient
  };
}
export function fetchIngredientFail(error) {
  return {
    type: constants.FETCH_INGREDIENT_FAIL,
    payload: error
  };
}

export function fetchGlobalIngredients() {
  return {
    type: constants.FETCH_GLOBAL_INGREDIENTS
  };
}
export function fetchGlobalIngredientsDone(ingredients) {
  return {
    type: constants.FETCH_GLOBAL_INGREDIENTS_DONE,
    payload: ingredients
  };
}
export function fetchGlobalIngredientsFail(error) {
  return {
    type: constants.FETCH_GLOBAL_INGREDIENTS_FAIL,
    payload: error
  };
}

export function fetchExcludedIngredients() {
  return {
    type: constants.FETCH_EXCLUDED_INGREDIENTS
  };
}
export function fetchExcludedIngredientsDone(ingredients) {
  return {
    type: constants.FETCH_EXCLUDED_INGREDIENTS_DONE,
    payload: ingredients
  };
}
export function fetchExcludedIngredientsFail(error) {
  return {
    type: constants.FETCH_EXCLUDED_INGREDIENTS_FAIL,
    payload: error
  };
}

export function excludeIngredients(itemCodes) {
  return {
    type: constants.EXCLUDE_INGREDIENTS,
    payload: itemCodes
  };
}
export function excludeIngredientsDone() {
  return {
    type: constants.EXCLUDE_INGREDIENTS_DONE
  };
}
export function excludeIngredientsFail(error) {
  return {
    type: constants.EXCLUDE_INGREDIENTS_FAIL,
    payload: error
  };
}

export function includeIngredients(itemCodes) {
  return {
    type: constants.INCLUDE_INGREDIENTS,
    payload: itemCodes
  };
}
export function includeIngredientsDone() {
  return {
    type: constants.INCLUDE_INGREDIENTS_DONE
  };
}
export function includeIngredientsFail(error) {
  return {
    type: constants.INCLUDE_INGREDIENTS_FAIL,
    payload: error
  };
}

// export function fetchMarketIngredients(marketCode) {
//   return {
//     type: constants.FETCH_MARKET_INGREDIENTS,
//     payload: marketCode
//   };
// }
// export function fetchMarketIngredientsDone(ingredients) {
//   return {
//     type: constants.FETCH_MARKET_INGREDIENTS_DONE,
//     payload: ingredients
//   };
// }
// export function fetchMarketIngredientsFail(error) {
//   return {
//     type: constants.FETCH_MARKET_INGREDIENTS_FAIL,
//     payload: error
//   };
// }
